import React from 'react'
import PropTypes from 'prop-types'
import { Box, Text, Flex } from 'pcln-design-system'

export const props = {
  /** JSDoc-style comments on props will appear in the Docs tab in Storybook */
  props: PropTypes.object,
}

/** @public */
const SopqTitleLearnMore: React.FC = () => {
  return (
    <Flex justifyContent='space-between'>
      <Flex alignItems='center'>
        <Box>
          <Box
            color='primary.base'
            mb='4px'
            ml='16px'
            mt='16px'
            width='118px'
            height='24px'
            borderRadius='8px'
            textAlign='center'
          >
            <Text textAlign='center' fontSize='12px' fontWeight='bold' color='white' p={1}>
              EXPRESS DEAL
            </Text>
          </Box>
          <Text textAlign='center' fontWeight='bold' color='#000000' fontSize='16px' mx={3} mb='16px'>
            How do they work?
          </Text>
        </Box>
      </Flex>
    </Flex>
  )
}

export default SopqTitleLearnMore
